import React from 'react'

function Chatbot() {
  (function(d, m){
    var kommunicateSettings = 
        {"appId":"183abd577f1985c3681266d29baad9f9a","popupWidget":true,"automaticChatOpenOnNavigation":true};
    var s = document.createElement("script"); s.type = "text/javascript"; s.async = true;
    s.src = "https://widget.kommunicate.io/v2/kommunicate.app";
    var h = document.getElementsByTagName("head")[0]; h.appendChild(s);
    window.kommunicate = m; m._globals = kommunicateSettings;
})(document, window.kommunicate || {});
  return (
    <div>
        <h1></h1>
    </div>
  )
}

export default Chatbot
